<!-- eslint-disable max-len -->
<template>
  <div class="mx-auto min-h-full">
    <SimpleHeader
      :on-close="handleClose"
      :pages="[
        { name: t('sidemenu.navigation.shared-report.title'), href: router.resolve({ name: 'PluginLivesSharedWithMePage' }).href, current: false },
        { name: t('sidemenu.navigation.report-details.title'), href: '#', current: true },
      ]"
    />
    <RouterView />
  </div>
  <SimpleFooter :horizontal="true" />
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import SimpleHeader from '@/components/tailwind/header/SimpleHeader.vue';
import SimpleFooter from '@/components/tailwind/footer/SimpleFooter.vue';

const router = useRouter();
const { t } = useI18n();

const handleClose = () => {
  router.push({ name: 'PluginLivesSharedWithMePage' });
};
</script>

<style scoped lang="scss">
</style>
